import { RootState } from "@/redux/root-reducer";
import { createSelector } from "reselect";

export const reducer = (state: RootState) => state.user_dashboard;

export const showSidebar = createSelector(
  [reducer],
  (reducer) => reducer.showSidebar
);
